import karina from '../images/Karina.png';
import jammmingIMG from '../images/Jammming.png';
import reactionGame from '../images/react-game.png';
import portraits from '../images/Moroccan.jpg';
import courseList from '../images/course-list-square2.png';
import tyro from '../images/tyro.png';
import beer from '../images/beer.png';
import reactris from '../images/reactris.png';
import squares from '../store/Squares';

export default {
    "name": "Home",
    "title": "Zhana Liner",
    "links": ['Message', 'Blog'],
    "images": {
        "reactris": reactris,
        "tyro": tyro,
        "beer": beer,
        "courseList": courseList,
        "karina": karina,
        "jammmingIMG": jammmingIMG,
        "reactionGame": reactionGame,
        "portraits": portraits,
    },
    "squares": squares,
    "background": "backgroundHome",
};
